import apiETCE from '../infra/apiETCE'

const ProcessoService = {
    PesquisaProcessual: async (codigoProcesso) => {
        return await apiETCE.get(`/api/v1/Processo/Pesquisaprocessual/${codigoProcesso}`)
    },
    PesquisaProcessualDoSetor: async (codigoProcesso, apenasDoSetor) => {
        return await apiETCE.get(`/api/v1/Processo/pesquisaprocessual/${codigoProcesso}/${apenasDoSetor}`)
    },
}

export default ProcessoService